export default function HeroSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 py-16 md:py-24 lg:py-28">
          {/* Left: Text Column */}
          <div className="w-full lg:w-[35%] flex flex-col justify-center">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 leading-[1.15] tracking-tight">
              Engineering Excellence for the iOS Platform
            </h2>
            <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-[420px]">
              A professional engineering team designing and developing modern digital software solutions with a relentless focus on usability, stability, and long-term technical quality.
            </p>
            <div className="mt-16 hidden lg:block" aria-hidden="true" />
          </div>

          {/* Middle: Large Abstract Image */}
          <div className="w-full lg:w-[35%]">
            <div className="relative rounded-lg overflow-hidden w-full" style={{ aspectRatio: '3/4' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20digital%20architecture%20with%20layered%20geometric%20structures%20in%20deep%20teal%20and%20warm%20coral%20tones%2C%20soft%20gradient%20lighting%2C%20minimal%20design%20aesthetic%2C%20clean%20lines%20and%20interconnected%20nodes%20suggesting%20software%20engineering%20systems%2C%20dark%20background%20with%20illuminated%20connection%20points%2C%20atmospheric%20depth%20of%20field%2C%20abstract%203D%20render%20with%20translucent%20layers%2C%20no%20text%20no%20people%20no%20devices&width=420&height=560&seq=hero-main-01&orientation=portrait"
                alt="Abstract digital architecture representing software engineering systems"
                title="Abstract digital architecture representing software engineering systems"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right: Image Grid Column */}
          <div className="w-full lg:w-[30%] flex flex-col justify-center">
            <div className="flex items-start justify-between mb-5">
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 leading-snug">
                Precision in Every Layer
              </h3>
              <span className="w-8 h-8 flex items-center justify-center text-accent-500 flex-shrink-0 mt-1" aria-hidden="true">
                <i className="ri-arrow-right-up-line text-xl"></i>
              </span>
            </div>

            <div className="flex flex-col gap-3">
              {/* Top large image */}
              <div className="relative rounded-lg overflow-hidden w-full" style={{ aspectRatio: '3/2' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20data%20flow%20patterns%2C%20intersecting%20translucent%20geometric%20shapes%20in%20warm%20coral%20and%20deep%20teal%20tones%2C%20modern%20tech%20aesthetic%2C%20clean%20composition%2C%20glowing%20edges%20against%20dark%20background%2C%20abstract%20rendering%2C%20no%20text%20no%20people%20no%20devices%2C%20smooth%20gradients&width=360&height=240&seq=hero-grid-01&orientation=landscape"
                  alt="Abstract data flow visualization"
                  title="Abstract data flow visualization"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Bottom two smaller images */}
              <div className="flex gap-3">
                <div className="relative rounded-lg overflow-hidden flex-1" style={{ aspectRatio: '1/1' }}>
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20code%20and%20structure%20visualization%2C%20microscale%20detail%20of%20layered%20translucent%20panels%2C%20soft%20focus%20edges%2C%20warm%20amber%20and%20coral%20highlights%20on%20dark%20surface%2C%20abstract%20engineering%20aesthetic%2C%20no%20text%20no%20people%20no%20devices%2C%20minimal%20geometric%20composition&width=200&height=200&seq=hero-grid-02&orientation=squarish"
                    alt="Abstract structure visualization"
                    title="Abstract structure visualization"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="relative rounded-lg overflow-hidden flex-1" style={{ aspectRatio: '1/1' }}>
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20technology%20mesh%20pattern%2C%20interconnected%20nodes%20forming%20an%20organic%20technical%20lattice%2C%20subtle%20gradient%20from%20teal%20to%20warm%20coral%2C%20soft%20illumination%2C%20clean%20minimal%20abstract%20render%2C%20no%20text%20no%20people%20no%20devices%2C%20smooth%20geometric%20flow&width=200&height=200&seq=hero-grid-03&orientation=squarish"
                    alt="Abstract technology mesh pattern"
                    title="Abstract technology mesh pattern"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}